<template>
  <div style="margin-left: 13px; margin-right: 13px;">
    <!-- <div class="row" style="margin-bottom: 20px; padding-left: 0px;">
      <div class="col-md-12 search align-baseline">
        <span class="fa fa-search"></span>
        <input
          type="text"
          class="form-control"
          name="searchText"
          id="searchText"
          placeholder="Search expenses, suppliers, property"
          v-model="filter"
        />
      </div>
    </div> -->

    <expenses
      :key="period"
      :building-id="buildingId"
      :headerbar="true"
      :period="period"
      :filter="filter"
    ></expenses>

    <!-- <div class="row row-table-title">
      <div
        class="col-12 margin-tb section-title dark-green-title"
        style="padding-top: 0px; padding-bottom: 0px;"
      >
        <div class="pull-left">
          <h2
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
            "
          >
            Creditors
          </h2>
        </div>
        <div class="pull-right" style="display: inline-flex;">
          <creditor-form-link v-if="isAdmin" :building-id="buildingId"
            >Pay Now</creditor-form-link
          >
          <a v-if="false"
            style="float: right; color: white; font-size: 14px;"
            target="_blank"
            :href="'/admin/expenses/creditorspdf/' + buildingId + '/' + period"
            >Download</a
          >
        </div>
      </div>
    </div> -->
    <div style="margin-left: -13px; margin-right: -13px;margin-top: 30px;" >
      <creditors
        :building-id="buildingId"
        :building-name="buildingName"
        :period="period"
        :key="period"
        :filter="filter"
        :dark="false"
      ></creditors>
    </div>
    <!-- <div class="row row-table-title">
      <div
        class="col-12 margin-tb section-title dark-green-title"
        style="padding-top: 0px; padding-bottom: 0px;"
      >
        <div class="pull-left">
          <h3
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
            "
          >
            Uncollected Income
          </h3>
        </div>

        <div
          class="pull-right"
          style="display: inline-flex; margin-right: -41px;"
        >
          <debtor-monthly-form-link
            v-if="isAdmin"
            :building-id="buildingId"
            :period="period"
            class="test"
            href="#"
            data-toggle="tooltip"
            data-placement="top"
            title="Amount will be deducted from Expenses"
            >Collect Monthly Income</debtor-monthly-form-link
          >
          <debtor-form-link
            v-if="isAdmin"
            :building-id="buildingId"
            class="test"
            href="#"
            data-toggle="tooltip"
            data-placement="top"
            title="Amount will be deducted from Additional Expenses"
            >Collect Share Payment</debtor-form-link
          >
        </div>
      </div>
    </div> -->

    <div style="margin-left: -13px; margin-right: -13px;margin-top:30px">
      <uncollected
        :building-id="buildingId"
        :key="period"
        :period="period"
        :filter="filter"
        :dark="false"
      ></uncollected>
    </div>

    <!-- <div class="row row-table-title">
      <div
        class="col-12 margin-tb section-title dark-green-title"
        style="padding-top: 0px; padding-bottom: 0px;"
      >
        <div class="pull-left">
          <h3
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
            "
          >
            Collected Income
          </h3>
        </div>
        <div class="pull-right" style="display: inline-flex;">
        </div>
      </div>
    </div> -->
    <div style="margin-left: -13px; margin-right: -13px;margin-top:30px">
      <collected
        :building-id="buildingId"
        :key="period"
        :period="period"
        :filter="filter"
        :dark="false"
      ></collected>
    </div>
  </div>
</template>
<style scoped>
.form-control {
  border-radius: 0px !important;
  border: rgb(124, 124, 124) 1px solid !important;
  vertical-align: text-bottom !important;
}
</style>
<script>
// $(document).ready(function(){
//     $('[data-toggle="tooltip"]').tooltip();
// });
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";

export default {
  props: ["buildingId", "buildingName", "route", "period","filter"],
  data: function () {
    return {
      index: 0,
      isModalVisible: true,
      expenseTypeId: 0,
      monthParam: 0,
      component: 0,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  mounted() {
    // alert(this.buildingId)
    if (this.buildingId) this.fetchStatement();
    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    fetchStatement: function () {
      var request = "/expenses/providers";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.expensesMonth = data.expensesMonth;
          this.totalFees = data.totalFees;
        });
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    isAdmin() {
      return (
        this.currentUser &&
        (this.currentUser.role === Role.Admin ||
          this.currentUser.role === Role.Management)
      );
    },
    isOwner() {
      return this.currentUser && this.currentUser.role === Role.Owner;
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    //  this.$store.dispatch('users/getAll');
  },
};
</script>
